import type { TrustedTerminalIdentity } from "./terminal-state";

let lastKey: string | null = null;
let lastIdentity: TrustedTerminalIdentity | null = null;

function identityKey(identity: TrustedTerminalIdentity) {
  return [
    identity.organization_id,
    identity.node_id,
    identity.node_code,
    identity.node_name,
    identity.node_type,
    identity.node_status,
    identity.branch_id,
    identity.branch_code,
    identity.branch_name,
    identity.commerce_channel_id,
    identity.commerce_channel_code,
    identity.credential_id,
    String(identity.credential_version),
    identity.credential_status,
  ].join("\u001f");
}

export function internTerminalIdentity(identity: TrustedTerminalIdentity) {
  const key = identityKey(identity);
  if (lastIdentity && lastKey === key) return lastIdentity;
  lastKey = key;
  lastIdentity = identity;
  return identity;
}
